import { render, staticRenderFns } from "./gallery.component.html?vue&type=template&id=4eba5421&scoped=true&"
import script from "./gallery.component.ts?vue&type=script&lang=ts&"
export * from "./gallery.component.ts?vue&type=script&lang=ts&"
import style0 from "./gallery.component.scss?vue&type=style&index=0&id=4eba5421&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba5421",
  null
  
)

export default component.exports